import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const ESTADOS = {
    1: 'Pendiente',
    2: 'Aprobado',
    3: 'Rechazado',
    4: 'Expirado'
};

const getStatusClass = (status) => ({
    1: 'pendiente',
    2: 'aprobado',
    3: 'rechazado',
    4: 'expirado'
}[status] ?? 'expirado');

const formatDate = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString('es-AR');
};

export default function CuponListItem({ coupon, status, isAdminView, canManageCoupons, isBusy, onAction }) {
    const estado = ESTADOS[status] ?? coupon.estado ?? '-';
    const discount = coupon.porcentajeDescuento != null
        ? `${coupon.porcentajeDescuento}% OFF`
        : coupon.valorDescuento != null
            ? `$ ${coupon.valorDescuento}`
            : '-';

    return (
        <article className="cupon-list-card admin-list-card">
            <div className="cupon-list-card__inner">
                <div className="cupon-list-card__head">
                    <div className="cupon-list-card__identity">
                        <div className="cupon-list-card__code">{coupon.codCupon}</div>
                        <div className="cupon-list-card__description">{coupon.descripcion}</div>
                        <div className="cupon-list-card__meta">
                            <span className="cupon-list-card__id-badge">Cupón #{coupon.idCupon}</span>
                            <span className={`cupon-list-card__status cupon-list-card__status--${getStatusClass(status)}`}>{estado}</span>
                        </div>
                    </div>
                    <div className="cupon-list-card__actions">
                        {canManageCoupons && status === 1 && <>
                            <Button size="sm" variant="success" disabled={isBusy} onClick={() => onAction(coupon, 2)}>Aceptar</Button>
                            <Button size="sm" variant="outline-danger" disabled={isBusy} onClick={() => onAction(coupon, 3)}>Rechazar</Button>
                        </>}
                        {canManageCoupons && !isAdminView && status === 2 && <Button size="sm" variant="outline-danger" disabled={isBusy} onClick={() => onAction(coupon, 'revoke')}>Revocar</Button>}
                        {isBusy && <Spinner animation="border" size="sm" />}
                    </div>
                </div>

                <div className="cupon-list-card__body">
                    <div className="cupon-list-card__details">
                        <div className="cupon-list-card__detail">
                            <span className="cupon-list-card__label">Vigencia</span>
                            <strong>{formatDate(coupon.fechaDesde)} al {formatDate(coupon.fechaHasta)}</strong>
                        </div>
                        <div className="cupon-list-card__detail">
                            <span className="cupon-list-card__label">Tope de reintegro</span>
                            <strong>{coupon.topeReintegro != null ? `$ ${coupon.topeReintegro}` : '-'}</strong>
                        </div>
                    </div>

                    <div className="cupon-list-card__kpis">
                        <div className="cupon-list-card__kpi cupon-list-card__kpi--highlight">
                            <span className="cupon-list-card__label">Descuento</span>
                            <strong>{discount}</strong>
                        </div>
                        <div className="cupon-list-card__kpi">
                            <span className="cupon-list-card__label">Aporte Seller</span>
                            <strong>{coupon.porcentajeAporteSeller ?? '-'}%</strong>
                        </div>
                        <div className="cupon-list-card__kpi">
                            <span className="cupon-list-card__label">Aporte Megatone</span>
                            <strong>{coupon.porcentajeAporteMegatone ?? '-'}%</strong>
                        </div>
                    </div>
                </div>

                {isAdminView && <div className="cupon-list-card__sellers">
                    <span className="cupon-list-card__label">Sellers asociados</span>
                    <div className="cupon-list-card__seller-list">
                        {coupon.sellers?.length > 0 ? coupon.sellers.map((seller, index) => (
                            <span className="cupon-list-card__seller" key={`${seller.idSeller ?? seller.IdSeller ?? index}`}>
                                <span className="cupon-list-card__seller-id">#{seller.idSeller ?? seller.IdSeller ?? '-'}</span>
                                <span>{seller.nombre ?? seller.Nombre ?? '-'}</span>
                            </span>
                        )) : <span className="cupon-list-card__seller-empty">Sin sellers asociados</span>}
                    </div>
                </div>}
            </div>
        </article>
    );
}
